import React from 'react';
import ReactDOM from 'react-dom';
import { Home } from './view/pages/Home';
import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Domain, clientId, redirectUri } from './config';
import './index.scss';

ReactDOM.render(
	<React.StrictMode>
		<Auth0Provider
			domain={auth0Domain}
			clientId={clientId}
			cacheLocation="localstorage"
			useRefreshTokens={false}
			redirectUri={redirectUri}
			scope="test"
		>
			<Home />
		</Auth0Provider>
	</React.StrictMode>,
	document.getElementById('root')
);